import styled from 'styled-components';

export const DataGetter = styled.div`
  > div {
    width: 100%;
  }
  .value_selector__control {
    background: none !important;
    border-bottom: none !important;
    width: 100%;
  }
  .Superops-Connected {
    padding-top: 0 !important;
  }
  .Superops-TextField {
    background: transparent;
  }
  .Superops-TextField__Input {
    padding-bottom: 0;
    border-bottom: 0 !important;
    max-height: 150px;
    min-height: 70px;
    overflow: auto;
  }
  .Superops-TextField--multiline > .Superops-TextField__Input {
    padding-top: 6px;
  }
`;

export const TimeCollector = styled.div`
  min-height: 38px;
  min-width: 60px;
  .Superops-TextField__Prefix,
  .Superops-TextField__Suffix {
    border-bottom: none !important;
    background: none !important;
  }
  .value_selector__control {
    background: none !important;
    border-bottom: none !important;
  }
  .Superops-Connected {
    padding-top: 0 !important;
    background: var(--sops-worklog-time-collector-bg);
    border-radius: 5px;
    padding: 0 5px;
  }
  .Superops-TextField {
    background: transparent;
    min-height: 38px;
  }
  .Superops-TextField__Input {
    padding-bottom: 0;
    border-bottom: 0 !important;
  }
  .Superops-TextField--multiline > .Superops-TextField__Input {
    padding-top: 6px;
  }
`;

export const DateWrapper = styled.div`
  transition: background 200ms linear;
  .react-datepicker__input-container > input,
  .react-datepicker__input-container,
  .react-datepicker-wrapper {
    height: 100%;
    width: 100%;
  }
  .react-datepicker__input-container > input {
    font-weight: 400 !important;
    border-width: none;
    border: none;
    border-bottom: none !important
    margin-right: 14px;
    padding: 6px;
    height: 100%;
    font-size: 14px;
  }
  .react-datepicker__tab-loop {
    position: relative;
  }
  .react-datepicker-wrapper {
    // width: auto;
    min-width: 100px;
    miax-width: 150px;
    background: var(--sops-worklog-timer-inlineHighlight-bg);
    border-radius: 5px;
  }
`;

export const Wrapper = styled.div`
  border-radius: 0 0px 10px 10px;
  transition: all 200ms linear;
`;

export const IconHolder = styled.div`
  padding: ${(props) => props.padding || '5px'};
  background: ${(props) => (props.selected ? '#fff4ce' : '#fff')};
  height: ${(props) => props.size || '32px'};
  width: ${(props) => props.size || '32px'};
  cursor: pointer;
  transition: background 200ms linear;

  svg {
    height: ${(props) => props.iconsize || '20px'};
    width: ${(props) => props.iconsize || '20px'};
  }
`;
